import {z} from 'zod'

export const ProspectDistributionDataSchema = z.object({
    rows: z.array(
        z
            .object({
                capacity_bucket: z.string(),
                prospect_count: z.number(),
            })
            .transform(({capacity_bucket, prospect_count}) => ({
                capacityBucket: capacity_bucket,
                prospectCount: prospect_count,
            })),
    ),
    total: z.number(),
})

export type ProspectDistributionData = z.infer<typeof ProspectDistributionDataSchema>
